import React from 'react';
import { API } from '@gin-betting/core';

import { Icon } from 'components';
import CountryTitle from '../CountryTitle';
import useCountryRegionItem from './useCountryRegionItem';

import arrowRight from 'assets/svg/arrow-left.svg';
import './countryRegionItem.scss';

interface Props {
    tournaments: API.CategorizerItem[];
    countryCode: string;
    countryName: string;
}

const CountryRegionItem: React.FC<Props> = ({
    tournaments,
    countryCode,
    countryName,
}) => {
    const { totalCount, handleClickCountryRegion } = useCountryRegionItem({
        countryCode,
        tournaments,
    });

    return (
        <div onClick={handleClickCountryRegion} styleName="container">
            <CountryTitle countryCode={countryCode} countryName={countryName} />
            <div styleName="right">
                <div styleName="counter">{totalCount}</div>
                <Icon styleName="arrow-icon" glyph={arrowRight} />
            </div>
        </div>
    );
};

export default React.memo(CountryRegionItem);
